export default "__VITE_ASSET__ByvTyl3h__"